
import dateFormat from 'vux/src/tools/date/format.js'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import noData from '@/common/components/noData/index.vue'
import loadMore from '@/common/components/load-more/index.vue'
import GDialog from "@/common/components/g-dialog/"
import loadmorelistMx from '@/common/mixin/loadmorelist.js'
import { parseTime } from '@/common/utils/Date.js'
import { getDepositOrderList, cancelOrder } from '@/common/api/Amount.js'

export default {
directives: { TransferDom },
mixins: [loadmorelistMx(getDepositOrderList, true, { pageSize: 7 }, true)],
filters: {
timeFilter(time){
return parseTime(time)
},
},
components: { GDialog, XButton, Flexbox, FlexboxItem, TransferDom, Popup, Divider, Group, Datetime, noData, loadMore },
data() {
return {
confirmVisible:false,
successVisible:false,
cancelQuery: {},
}
},
created() {
},
methods: {
handleContinuePay(v) { // 继续支付
window.open(v)
},

handleConfirm({ id, orderNo }){ // 点击打开确认是否取消弹框
this.cancelQuery = { id, orderNo }
this.confirmVisible = true
},


handleCancelOrder(){
cancelOrder({ UUID:this.$store.state.UUID, orderId: this.cancelQuery.id }).then(([data, err, res]) => {
this.confirmVisible = false
if (!err) {
this.successVisible = true;
this.handleFetch()
} else {
this.$vux.toast.show({ text: res.data.msg || res.data.message, type: 'cancel'})
}
})
},

getparams() { // 获取参数
return { UUID: this.$Cookies.get('UUID') }
}

}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/LatestDeposit/index.vue